export const environment = {
  production: true,
  apiUrl: 'https://api.beta.sqdo.emma.io',
  baseUrl: 'https://beta.sqdo.emma.io',
  trackerUrl: 'https://track.beta.sqdo.emma.io',
  recaptchaSiteKey: '6LfvebslAAAAAEEt015X44SdOdIQC-CwENzyEl3Q',
  emmaDomain: 'ng-beta.emma.io',
};
